import React from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { ContentBanner } from '@xingternal/banner';
import { IconTick } from '@xingternal/icons';
import { spaceM, spaceXXL } from '@xingternal/tokens';
import { BodyCopy } from '@xingternal/typography';

type Props = {
  appliedDate: string;
};

const Banner = styled(ContentBanner)`
  margin-top: ${spaceXXL};
  margin-bottom: 48px;
  padding: ${spaceM};
  justify-content: center;
`;

const Icon = styled(IconTick)`
  margin-right: ${spaceM};
`;

export const ApplyConfirmation: React.VFC<Props> = ({ appliedDate }) => (
  <Banner variant="default" display="inline" noPadding>
    <Icon width={18} height={18} />
    <BodyCopy size="small" noMargin>
      <FormattedMessage
        id="JOBS_DETAIL_PREVIOUSLY_APPLIED_CONFIRMATION"
        values={{ date: <FormattedDate value={appliedDate} year="numeric" month="short" day="2-digit" /> }}
      />
    </BodyCopy>
  </Banner>
);
